<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية"><div class="section level2" id="narcissistic" style="padding-top:130px">
<p><span dir="rtl">أنت لا تعرف كُلَّ شيء، لذا لا تتوقع الكثير.</span></p>
<br/><br/>
<p style="text-align:center; direction:ltr">You don’t know anything, so don’t expect more.</p>
<br/>
<p><span dir="rtl">عندما ترفع سقف التوقعات بأعمدة ليست ثابتة؛ سينهار عليك ويقتلك.</span></p>
<br/>
<p style="text-align:center; direction:ltr">When your expectations are so high, they may fall</p>
<p style="text-align:center; direction:ltr">upon you and kill you.</p>
<br/><p style="text-align:center">******</p>
<br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?e056c53a